import { i18n } from 'fishx';
import { getFormErrorI18n } from '@/utils';

export const getBaseNameKey = (unitId, itemIndex, servType) => `_unitId${unitId}_item${itemIndex}_servType_${servType}`;

export const getUnitFormItems = (itemsDataGroup, formItemFun) => {
  const { offerList, numberProps, number = {}, modelKey, qrySalesRuleParams, mainOfferCurrentDpp } = itemsDataGroup;
  const { getFormItemName, handleNumberSelect } = formItemFun || {};
  return [
    {
      label: i18n('SELECT_OFFER_PLAN'),
      name: getFormItemName('offerDetail'),
      options: {
        // initialValue: {
        //   offerId: offerDetail.subsPlanId,
        //   offerName: offerDetail.subsPlanName,
        //   description: offerDetail.comments,
        //   displayOtcPrice: offerDetail.dispayOtc,
        //   ...offerDetail,
        // },
        rules: [{ required: true, message: getFormErrorI18n(i18n('SELECT_OFFER_PLAN')) }],
      },
      type: 'offerSelectModal',
      formItemCompProps: {
        modelKey,
        mainOfferCurrentDpp,
        isDrawer: true,
        addressId: numberProps.addressId,
        qrySalesRuleParams,
        dataGroup: offerList.map(it => ({
          offerId: it.subsPlanId,
          offerName: it.subsPlanName,
          description: it.comments,
          displayOtcPrice: it.displayOtc,
          displayRentPrice: it.displayMrc,
          ...it,
        })),
      },
    },
    {
      label: i18n('SELECT_NUMBER'),
      name: getFormItemName('number'),
      options: {
        initialValue: number,
        rules: [{ required: true, message: getFormErrorI18n(i18n('SELECT_NUMBER')) }],
      },
      type: 'numberSelect',
      formItemCompProps: {
        onChange: value => handleNumberSelect(value, getFormItemName('number')),
        ...numberProps,
      },
    },
  ];
};
